import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { injectIntl, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import appConfig from '../../appConfig';
import PanelTree from '../PanelTree';
import { validateSessionConnection } from '../../actions/session';
import {
  getLabelFromAppConfig,
  showAuthWorkflowTemplate,
  showWorkflowDashTemplate,
  showMetaEditTool,
  showUsersAndRolesScreen,
  showManageCatRolesScreen,
  showNewRecordTool,
  showLoaderTool,
  showExportMetaTool,
} from '../../utils/uiUtils';
import { showLocalAdminAsMain } from '../../actions/mainUI';
import {
  ADMIN_PUBLISH,
} from '../../constants/mainContentTypes';
import NotificationBoxIcon from '../Icons/NotificationBox';
import MetadataAttachIcon from '../Icons/MetadataAttach';
import WorkflowDashboardIcon from '../Icons/WorkflowDashboardDefault';
import UsersRolesIcon from '../Icons/UsersRolesDefault';
import AddNewRecordIcon from '../Icons/AddNewRecordDefault';
import RolesManagerIcon from '../Icons/RolesManagerDefult';
import PhotographyRequestIcon from '../Icons/PhotographyRequestDefault';
import { primaryTextColor } from '../../themes/index';

const OPTION_AUTHWORKFLOW = 'AUTHWORKFLOW';
const OPTION_WORKFLOWDASH = 'WORKFLOWDASH';
const OPTION_METAATTACH = 'OPTION_METAATTACH';
const OPTION_USERSANDROLES = 'OPTION_USERSANDROLES';
const OPTION_MANAGECATEGORYROLES = 'OPTION_MANAGECATEGORYROLES';
const OPTION_PUBLISH = 'OPTION_PUBLISH';
const OPTION_CREATERELATIONAL = 'OPTION_CREATERELATIONAL';
const OPTION_MANAGE_LOADER = 'OPTION_MANAGE_LOADER';
const OPTION_IMPORT_METADATA = 'OPTION_IMPORT_METADATA';

const mapDispatchToProps = (dispatch) => ({
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
  validateSession: (surl) => dispatch(validateSessionConnection(surl)),
  showPublishAdminScreen: () => dispatch(showLocalAdminAsMain(ADMIN_PUBLISH)),
});

const mapStateToProps = (state) => ({
  session: state.session,
});

function NavAdminPanel({
  dispatch, session, validateSession, showPublishAdminScreen,
}) {
  let optionsList;
  const intl = useIntl();
  if (appConfig.menuOptions
    && appConfig.menuOptions.adminMenu
    && appConfig.menuOptions.adminMenu.length > 0) {
    const { adminMenu } = appConfig.menuOptions;
    optionsList = new List();

    adminMenu.forEach((value) => {
      switch (value) {
        case 'auth':
          optionsList = optionsList.push(new Map({
            i: OPTION_AUTHWORKFLOW,
            n: getLabelFromAppConfig(appConfig.templates.authoriseWorkflow, intl.locale),
            icon: <NotificationBoxIcon stroke={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case 'workflowDash':
          optionsList = optionsList.push(new Map({
            i: OPTION_WORKFLOWDASH,
            n: getLabelFromAppConfig(appConfig.templates.workflowDashboard, intl.locale),
            icon: <WorkflowDashboardIcon stroke={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case 'metaAttach':
          optionsList = optionsList.push(new Map({
            i: OPTION_METAATTACH,
            n: intl.formatMessage({ id: 'navAdminPanel.metaAttach' }),
            icon: <MetadataAttachIcon stroke={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case 'usersAndRoles':
          optionsList = optionsList.push(new Map({
            i: OPTION_USERSANDROLES,
            n: intl.formatMessage({ id: 'navAdminPanel.usersAndRoles' }),
            icon: <UsersRolesIcon fill={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case 'manageCategoryRoles':
          optionsList = optionsList.push(new Map({
            i: OPTION_MANAGECATEGORYROLES,
            n: intl.formatMessage({ id: 'navAdminPanel.manageCategoryRoles' }),
            icon: <RolesManagerIcon fill={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case 'publish':
          optionsList = optionsList.push(new Map({
            i: OPTION_PUBLISH,
            n: intl.formatMessage({ id: 'navAdminPanel.publishBtn' }),
            icon: <PhotographyRequestIcon fill={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case 'newRelational':
          optionsList = optionsList.push(new Map({
            i: OPTION_CREATERELATIONAL,
            n: intl.formatMessage({ id: 'navAdminPanel.createRelationalBtn' }),
            icon: <AddNewRecordIcon width={14} height={14} stroke={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case 'loader':
          optionsList = optionsList.push(new Map({
            i: OPTION_MANAGE_LOADER,
            n: intl.formatMessage({ id: 'navAdminPanel.manageLoader' }),
            icon: <NotificationBoxIcon stroke={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        case 'importMetadata':
          optionsList = optionsList.push(new Map({
            i: OPTION_IMPORT_METADATA,
            n: intl.formatMessage({ id: 'navAdminPanel.importMetadata' }),
            icon: <MetadataAttachIcon stroke={primaryTextColor} style={{ margin: '0 6px' }} />,
          }));
          break;
        default:
          break;
      }
    });
  }

  const onPanelItemClick = (key) => {
    const surl = session ? session.get('surl') : sessionStorage.surl;
    validateSession(surl).then((res) => {
      if (res.isValid) {
        switch (key) {
          case OPTION_AUTHWORKFLOW:
            showAuthWorkflowTemplate(dispatch, session.get('locale'));
            break;
          case OPTION_METAATTACH:
            showMetaEditTool(null, dispatch);
            break;
          case OPTION_WORKFLOWDASH:
            showWorkflowDashTemplate(dispatch, session.get('locale'));
            break;
          case OPTION_USERSANDROLES:
            showUsersAndRolesScreen(dispatch, session.get('locale'));
            break;
          case OPTION_MANAGECATEGORYROLES:
            showManageCatRolesScreen(dispatch, appConfig.restrictEditing);
            break;
          case OPTION_PUBLISH:
            showPublishAdminScreen();
            break;
          case OPTION_CREATERELATIONAL:
            showNewRecordTool(dispatch);
            break;
          case OPTION_MANAGE_LOADER:
            showLoaderTool(dispatch);
            break;
          case OPTION_IMPORT_METADATA:
            showExportMetaTool(dispatch);
            break;
          default: break;
        }
      }
    });
  };

  return (
    <div className="nav-content__body">
      <h2 className="nav-content__title">{intl.formatMessage({ id: 'navAdminPanel.adminHeader' })}</h2>
      <PanelTree
        onPanelItemClick={onPanelItemClick}
        panelTreeList={optionsList}
        isRoot
      />
    </div>
  );
}

NavAdminPanel.propTypes = {
  dispatch: PropTypes.func,
  session: PropTypes.instanceOf(Map),
  validateSession: PropTypes.func,
  showPublishAdminScreen: PropTypes.func,
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(NavAdminPanel));
